import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
  Button,
  FormControlLabel,
  Radio,
} from "@mui/material";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from "../ConstantsEN";
import SharedHelmet from "../Helmet";
const TITLE = "Sleep Cycle calculator - Calculate Sleep Time";
const DESCRIPTION = "Use our Sleep Calculator to find out your optimal wake-up time or how much sleep you need based on your sleep cycles and daily requirements. Learn more about improving your sleep quality and the importance of good sleep habits.";
const KEYWORDS = "Sleep Calculator, Sleep Cycle Calculator, REM Sleep Calculator, Sleep Time Calculator, Hours of Sleep Calculator, Calculate Sleep Duration, Sleep Estimator";
const OG_URL = "https://do-calculate.com/calculator/en/sleep/";
const data1 = [
  { ageGroup: "0–3 months", recommendedHours: "14–17 hours" },
  {
    ageGroup: "4–12 months",
    recommendedHours: "12–16 hours within a 24-hour period including nap time",
  },
  {
    ageGroup: "1–2 years",
    recommendedHours: "11–14 hours within a 24-hour period including nap time",
  },
  {
    ageGroup: "3–5 years",
    recommendedHours: "10–13 hours within a 24-hour period including nap time",
  },
  {
    ageGroup: "6–12 years",
    recommendedHours: "9–12 hours within a 24-hour period",
  },
  {
    ageGroup: "13–18 years",
    recommendedHours: "8–10 hours within a 24-hour period",
  },
  {
    ageGroup: "18–60 years",
    recommendedHours: "7 or more hours in a single night",
  },
  { ageGroup: "61–64 years", recommendedHours: "7-9 hours" },
  { ageGroup: "65 years and older", recommendedHours: "7–8 hours" },
];
function SleapCalculator() {
  const [sleepType, setSleepType] = useState("wakeup");
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [pmAm, setPmAm] = useState("AM");
  const [sleepCycle, setSleepCycle] = useState("");
  const [takesToSleep, setTakesToSleep] = useState("");
  const [hoursError, setHoursError] = useState("");
  const [minutesError, setMinutesError] = useState("");
  const [sleepCycleError, setSleepCycleError] = useState("");
  const [takesToSleepError, setTakesToSleepError] = useState("");
  const [result1, setResult1] = useState("");
  const [sleepType2, setSleepType2] = useState("wakeup");
  const [hours2, setHours2] = useState("");
  const [minutes2, setMinutes2] = useState("");
  const [pmAm2, setPmAm2] = useState("AM");
  const [sleepHours, setSleepHours] = useState("");
  const [sleepMinutes, setSleepMinutes] = useState("");
  const [hoursError2, setHoursError2] = useState("");
  const [minutesError2, setMinutesError2] = useState("");
  const [sleepHoursError, setSleepHoursError] = useState("");
  const [sleepMinutesError, setSleepMinutesError] = useState("");
  const [result2, setResult2] = useState("");
  const handleHoursChange = (event) => {
    const inputHours = event.target.value;
    if (inputHours !== "") {
      const parsedHours = parseInt(inputHours, 10);
      if (!isNaN(parsedHours) && parsedHours <= 12) {
        setHours(inputHours);
        setHoursError("");
      } else {
        setHours("");
        if (isNaN(parsedHours)) {
          setHoursError("Make sure to enter a number");
        } else if (parsedHours > 12) {
          setHours(inputHours);
          setHoursError("Number of hours should be 12 hours");
        }
      }
    } else {
      setHours("");
      setHoursError("");
    }
  };
  const handleMinutesChange = (event) => {
    const inputMinutes = event.target.value;
    if (inputMinutes !== "") {
      const parsedMinutes = parseInt(inputMinutes, 10);
      if (!isNaN(parsedMinutes) && parsedMinutes <= 60) {
        setMinutes(inputMinutes);
        setMinutesError("");
      } else {
        setMinutes("");
        if (isNaN(parsedMinutes)) {
          setMinutesError("Make sure to enter a number");
        } else if (parsedMinutes > 60) {
          setMinutes(inputMinutes);
          setMinutesError("Minutes should be within 60 minutes per hour");
        }
      }
    } else {
      setMinutes("");
      setHoursError("");
    }
  };
  const handleTakesToSleepChange = (event) => {
    const inputTakesToSleep = event.target.value;
    if (inputTakesToSleep !== "") {
      if (!isNaN(inputTakesToSleep)) {
        setTakesToSleep(inputTakesToSleep);
        setTakesToSleepError("");
      } else {
        setTakesToSleep("");
        if (isNaN(inputTakesToSleep)) {
          setTakesToSleepError("Make sure to enter a number");
        }
      }
    } else {
      setTakesToSleep("");
      setTakesToSleepError("");
    }
  };
  const handleSleepCycleChange = (event) => {
    const inputSleepCycle = event.target.value;
    if (inputSleepCycle !== "") {
      if (!isNaN(inputSleepCycle)) {
        setSleepCycle(inputSleepCycle);
        setSleepCycleError("");
      } else {
        setSleepCycle("");
        if (isNaN(inputSleepCycle)) {
          setSleepCycleError("Make sure to enter a number");
        }
      }
    } else {
      setSleepCycle("");
      setSleepCycleError("");
    }
  };
  const handleSubmitCycle = (e) => {
    e.preventDefault();
    if (sleepType === "wakeup") {
      let wakeupTimeMinutes = parseInt(hours) * 60 + parseInt(minutes);
      if (pmAm === "PM") {
        wakeupTimeMinutes += 12 * 60;
      }
      const sleepCycles = Math.floor(wakeupTimeMinutes / sleepCycle);
      const bedtimes = [];
      for (let i = sleepCycles; i >= 1; i--) {
        const bedtimeMinutes =
          wakeupTimeMinutes - i * sleepCycle - Number(takesToSleep);
        let bedtimeHours = Math.floor(bedtimeMinutes / 60);
        let bedtimeMinutesFormatted = bedtimeMinutes % 60;
        if (bedtimeHours < 0) {
          bedtimeHours += 24;
        }
        if (bedtimeHours >= 12) {
          bedtimeHours -= 12;
        }
        if (bedtimeHours === 0) {
          bedtimeHours = 12;
        }
        bedtimes.push({
          hours: bedtimeHours,
          minutes: bedtimeMinutesFormatted,
          cycles: i,
        });
      }
      let result = `To wake up refreshed at ${hours}:${minutes} ${pmAm},\nit is recommended to go to sleep at one of the following times:\n\n`;
      bedtimes.forEach((bedtime) => {
        result += `${bedtime.hours}:${bedtime.minutes
          .toString()
          .padStart(2, "0")} ${bedtime.hours < 12 ? "PM" : "AM"}\t(${
          bedtime.cycles
        } sleep cycles)\n`;
      });
      if (bedtimes.length > 0) {
        for (let i = bedtimes[0].cycles + 1; i <= 7; i++) {
          const bedtimeMinutes =
            wakeupTimeMinutes - i * sleepCycle - Number(takesToSleep);
          let bedtimeHours = Math.floor(bedtimeMinutes / 60);
          let bedtimeMinutesFormatted = bedtimeMinutes % 60;
          if (bedtimeHours < 0) {
            bedtimeHours += 24;
          }
          if (bedtimeHours >= 12) {
            bedtimeHours -= 12;
          }
          if (bedtimeHours === 0) {
            bedtimeHours = 12;
          }
          result += `${bedtimeHours}:${bedtimeMinutesFormatted
            .toString()
            .padStart(2, "0")} ${
            bedtimeHours < 12 ? "PM" : "AM"
          }\t(${i} sleep cycles)\n`;
        }
      }
      setResult1(result);
    } else if (sleepType === "goToSleep") {
      let bedtimeMinutes = parseInt(hours) * 60 + parseInt(minutes);
      if (pmAm === "PM") {
        bedtimeMinutes += 12 * 60;
      }
      const sleepCycles = Math.floor(bedtimeMinutes / sleepCycle);
      const wakeuptimes = [];
      for (let i = sleepCycles + 1; i <= sleepCycles + 7; i++) {
        const wakeupTimeMinutes =
          bedtimeMinutes + i * sleepCycle + Number(takesToSleep);
        let wakeupHours = Math.floor(wakeupTimeMinutes / 60);
        let wakeupMinutesFormatted = wakeupTimeMinutes % 60;
        if (wakeupHours >= 24) {
          wakeupHours -= 24;
        }
        let pmAm = "AM";
        if (wakeupHours >= 12) {
          pmAm = "PM";
          if (wakeupHours > 12) {
            wakeupHours -= 12;
          }
        }
        if (wakeupHours === 0) {
          wakeupHours = 12;
        }
        wakeuptimes.push({
          hours: wakeupHours,
          minutes: wakeupMinutesFormatted,
          cycles: i,
          pmAm: pmAm,
        });
      }
      let result = `If you go to sleep at ${hours}:${minutes} ${pmAm},\nit is recommended to wake up at one of the following times to wake up refreshed:\n\n`;
      wakeuptimes.forEach((wakeup) => {
        result += `${wakeup.hours}:${wakeup.minutes
          .toString()
          .padStart(2, "0")} ${wakeup.pmAm}\t(${wakeup.cycles} sleep cycles)\n`;
      });
      if (wakeuptimes.length > 0) {
        result +=
          "\nIf you have different arrangements, you can also choose one of the following times:\n\n";
        for (let i = sleepCycles - 1; i >= 1; i--) {
          const wakeupTimeMinutes =
            bedtimeMinutes + i * sleepCycle + Number(takesToSleep);
          let wakeupHours = Math.floor(wakeupTimeMinutes / 60);
          let wakeupMinutesFormatted = wakeupTimeMinutes % 60;
          if (wakeupHours >= 24) {
            wakeupHours -= 24;
          }
          let pmAm = "AM";
          if (wakeupHours >= 12) {
            pmAm = "PM";
            if (wakeupHours > 12) {
              wakeupHours -= 12;
            }
          }
          if (wakeupHours === 0) {
            wakeupHours = 12;
          }
          result += `${wakeupHours}:${wakeupMinutesFormatted
            .toString()
            .padStart(2, "0")} ${pmAm}\t(${i} sleep cycles)\n`;
        }
      }
      result += `If you wake up at one of the mentioned times above,\nyou will wake up in the middle of a sleep cycle lasting ${sleepCycle} minutes,\nassuming it takes ${takesToSleep} minutes to fall asleep.\nIt is recommended to get ${sleepCycles}-${
        sleepCycles + 1
      }\ncomplete sleep cycles each night.`;
      setResult1(result);
    }
  };
  const onReset1 = () => {
    setSleepType("wakeup");
    setHours("");
    setMinutes("");
    setPmAm("AM");
    setSleepCycle("");
    setTakesToSleep("");
    setHoursError("");
    setMinutesError("");
    setSleepCycleError("");
    setTakesToSleepError("");
    setResult1("");
  };
  const handleHours2Change = (event) => {
    const inputHours = event.target.value;
    if (inputHours !== "") {
      const parsedHours = parseInt(inputHours, 10);
      if (!isNaN(parsedHours) && parsedHours <= 12) {
        setHours2(inputHours);
        setHoursError2("");
      } else {
        setHours2("");
        if (isNaN(parsedHours)) {
          setHoursError2("Make sure to enter a number");
        } else if (parsedHours > 12) {
          setHours2(inputHours);
          setHoursError2("Number of hours should be 12 hours");
        }
      }
    } else {
      setHours2("");
      setHoursError2("");
    }
  };
  const handleMinutes2Change = (event) => {
    const inputMinutes = event.target.value;
    if (inputMinutes !== "") {
      const parsedMinutes = parseInt(inputMinutes, 10);
      if (!isNaN(parsedMinutes) && parsedMinutes <= 60) {
        setMinutes2(inputMinutes);
        setMinutesError2("");
      } else {
        setMinutes2("");
        if (isNaN(parsedMinutes)) {
          setMinutesError2("Make sure to enter a number");
        } else if (parsedMinutes > 60) {
          setMinutes2(inputMinutes);
          setMinutesError2("Minutes should be within 60 minutes per hour");
        }
      }
    } else {
      setMinutes2("");
      setHoursError2("");
    }
  };
  const handleSleepHoursChange = (event) => {
    const inputSleepCycle = event.target.value;
    if (inputSleepCycle !== "") {
      if (!isNaN(inputSleepCycle)) {
        setSleepHours(inputSleepCycle);
        setSleepHoursError("");
      } else {
        setSleepHours("");
        if (isNaN(inputSleepCycle)) {
          setSleepHoursError("Make sure to enter a number");
        }
      }
    } else {
      setSleepHours("");
      setSleepHoursError("");
    }
  };
  const handleSleepMinutesChange = (event) => {
    const inputTakesToSleep = event.target.value;
    if (inputTakesToSleep !== "") {
      if (!isNaN(inputTakesToSleep)) {
        setSleepMinutes(inputTakesToSleep);
        setSleepMinutesError("");
      } else {
        setSleepMinutes("");
        if (isNaN(inputTakesToSleep)) {
          setSleepMinutesError("Make sure to enter a number");
        }
      }
    } else {
      setSleepMinutes("");
      setSleepMinutesError("");
    }
  };
  const handleSubmitLength = (e) => {
    e.preventDefault();
    if (sleepType2 === "wakeup") {
      const wakeUpHour = parseInt(hours2, 10);
      const wakeUpMinute = parseInt(minutes2, 10);
      const sleepHour = parseInt(sleepHours, 10);
      const sleepMinute = parseInt(sleepMinutes, 10);
      let bedHour = wakeUpHour - sleepHour;
      let bedMinute = wakeUpMinute - sleepMinute;
      let updatedPmAm2 = pmAm2;
      if (bedMinute < 0) {
        bedHour -= 1;
        bedMinute += 60;
      }
      if (bedHour < 0) {
        bedHour += 12;
        updatedPmAm2 = pmAm2 === "AM" ? "PM" : "AM";
      }
      const result = `You should go to bed at: ${bedHour}:${bedMinute
        .toString()
        .padStart(2, "0")} ${updatedPmAm2}`;
      setResult2(result);
    } else if (sleepType2 === "goToSleep") {
      const sleepHour = parseInt(hours2, 10);
      const sleepMinute = parseInt(minutes2, 10);
      const wakeUpHour = parseInt(sleepHours, 10);
      const wakeUpMinute = parseInt(sleepMinutes, 10);
      let updatedPmAm2 = pmAm2;
      let wakeHour = wakeUpHour + sleepHour;
      let wakeMinute = wakeUpMinute + sleepMinute;
      if (wakeMinute >= 60) {
        wakeHour += 1;
        wakeMinute -= 60;
      }
      if (wakeHour >= 12) {
        wakeHour -= 12;
        updatedPmAm2 = pmAm2 === "AM" ? "PM" : "AM";
      }
      const result = `You should wake up at: ${wakeHour}:${wakeMinute
        .toString()
        .padStart(2, "0")} ${updatedPmAm2}`;
      setResult2(result);
    }
  };
  const onReset2 = () => {
    setSleepType2("wakeup");
    setHours2("");
    setMinutes2("");
    setPmAm2("AM");
    setSleepHours("");
    setSleepMinutes("");
    setHoursError2("");
    setMinutesError2("");
    setSleepHoursError("");
    setSleepMinutesError("");
    setResult2("");
  };
  return (
    <div>
        <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "32px" }}
          >
            <h1 style={{ fontSize: "14px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
            <div>
    <p>
        Welcome to our Sleep Calculator! This tool helps you determine the ideal wake-up time or required sleep duration based on your sleep cycles. Simply input your bedtime or wake-up time, and the calculator will provide you with optimal sleep times and suggestions to enhance your sleep quality.
    </p>
    <p>
        With our Sleep Calculator, you can:
        <ul>
            <li>Calculate your wake-up time based on the sleep cycle you are aiming for.</li>
            <li>Estimate the amount of sleep needed to wake up refreshed and at your best.</li>
            <li>Get insights into REM cycles and how they affect your sleep quality.</li>
            <li>Understand the impact of sleep patterns on your overall health and well-being.</li>
        </ul>
    </p>
    <p>
        Use this tool to optimize your sleep routine and learn more about the importance of healthy sleep. Accurate sleep calculations can help you maintain a balanced and healthy lifestyle.
    </p>
    <hr />
</div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Sleep cycle calculator
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmitCycle}>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label >I want to</label>
                    </b>
                    <div style={{ marginRight: "40px" }}>
                      <FormControlLabel
                        value="wakeup"
                        control={
                          <Radio
                            color="success"
                            checked={sleepType === "wakeup"}
                            onChange={(e) => setSleepType(e.target.value)}
                          />
                        }
                        label="Wake up on time"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="goToSleep"
                        control={
                          <Radio
                            color="success"
                            checked={sleepType === "goToSleep"}
                            onChange={(e) => setSleepType(e.target.value)}
                          />
                        }
                        label="I sleep on time"
                        labelPlacement="start"
                      />
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <TextField
                      label="Hours"
                      name="hours"
                      value={hours}
                      onChange={handleHoursChange}
                      error={!!hoursError}
                      helperText={hoursError}
                      inputProps={{
                        required: true,
                        placeholder: "5",
                      }}
                      sx={{
                        width: "80px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <span style={{ marginLeft: "10px" }}> : </span>
                    <TextField
                      label="Minutes"
                      name="minutes"
                      value={minutes}
                      onChange={handleMinutesChange}
                      error={!!minutesError}
                      helperText={minutesError}
                      inputProps={{
                        required: true,
                        placeholder: "20",
                      }}
                      sx={{
                        width: "80px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <span style={{ marginLeft: "10px" }}> : </span>
                    <Select
                      value={pmAm}
                      onChange={(e) => setPmAm(e.target.value)}
                      size="small"
                      color="success"
                      sx={{
                        width: "80px",
                        overflow: "hidden",
                        backgroundColor: "#f9f9f9",
                        fontSize: "14px",
                        padding: "2px 0",
                        ml: "10px",
                      }}
                    >
                      <MenuItem value={"AM"}>AM</MenuItem>
                      <MenuItem value={"PM"}>PM</MenuItem>
                    </Select>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <TextField
                      label="My Sleep Cycle"
                      name="sleepCycle"
                      value={sleepCycle}
                      onChange={handleSleepCycleChange}
                      error={!!sleepCycleError}
                      helperText={sleepCycleError}
                      inputProps={{
                        required: true,
                        placeholder: "30",
                      }}
                      sx={{
                        width: "130px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <TextField
                      label="Takes To Sleep"
                      name="takesToSleep"
                      value={takesToSleep}
                      onChange={handleTakesToSleepChange}
                      error={!!takesToSleepError}
                      helperText={takesToSleepError}
                      inputProps={{
                        required: true,
                        placeholder: "30",
                      }}
                      sx={{
                        width: "140px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                  </div>
                  <hr />
                  <div className="mb-3">
                    <Button
                      type="submit"
                      color="success"
                      sx={{
                        backgroundColor: "rgb(25,135,84)",
                        fontSize: "15px",
                        marginRight: "25px",
                        padding: "5px 25px",
                        color: "white",
                      }}
                    >
                      Calculate
                    </Button>
                    <Button
                      sx={{
                        backgroundColor: "rgb(108,117,125)",
                        fontSize: "15px",
                        marginRight: "25px",
                        padding: "5px 25px",
                        color: "white",
                      }}
                      onClick={onReset1}
                    >
                      Clear
                    </Button>
                  </div>
                </form>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-9">
                {result1 && <pre>{result1}</pre>}
              </div>
            </div>
            <hr />
            <br />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Sleep Length Calculator
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmitLength}>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label >I want to</label>
                    </b>
                    <div style={{ marginRight: "40px" }}>
                      <FormControlLabel
                        value="wakeup"
                        control={
                          <Radio
                            color="success"
                            checked={sleepType2 === "wakeup"}
                            onChange={(e) => setSleepType2(e.target.value)}
                          />
                        }
                        label="Wake up at"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="goToSleep"
                        control={
                          <Radio
                            color="success"
                            checked={sleepType2 === "goToSleep"}
                            onChange={(e) => setSleepType2(e.target.value)}
                          />
                        }
                        label="Go to sleep at"
                        labelPlacement="start"
                      />
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <TextField
                      label="Hours"
                      name="hours"
                      value={hours2}
                      onChange={handleHours2Change}
                      error={!!hoursError2}
                      helperText={hoursError2}
                      inputProps={{
                        required: true,
                        placeholder: "5",
                      }}
                      sx={{
                        width: "80px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <span style={{ marginLeft: "10px" }}> : </span>
                    <TextField
                      label="Minutes"
                      name="minutes"
                      value={minutes2}
                      onChange={handleMinutes2Change}
                      error={!!minutesError2}
                      helperText={minutesError2}
                      inputProps={{
                        required: true,
                        placeholder: "20",
                      }}
                      sx={{
                        width: "80px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <span style={{ marginLeft: "10px" }}> : </span>
                    <Select
                      value={pmAm2}
                      onChange={(e) => setPmAm2(e.target.value)}
                      size="small"
                      color="success"
                      sx={{
                        width: "80px",
                        overflow: "hidden",
                        backgroundColor: "#f9f9f9",
                        fontSize: "14px",
                        padding: "2px 0",
                        ml: "10px",
                      }}
                    >
                      <MenuItem value={"AM"}>AM</MenuItem>
                      <MenuItem value={"PM"}>PM</MenuItem>
                    </Select>
                  </div>
                  <b>
                    <label >I want to sleep for</label>
                  </b>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <TextField
                      label="Hours"
                      name="sleepHours"
                      value={sleepHours}
                      onChange={handleSleepHoursChange}
                      error={!!sleepHoursError}
                      helperText={sleepHoursError}
                      inputProps={{
                        required: true,
                        placeholder: "30",
                      }}
                      sx={{
                        width: "130px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <TextField
                      label="Minutes"
                      name="sleepMinutes"
                      value={sleepMinutes}
                      onChange={handleSleepMinutesChange}
                      error={!!sleepMinutesError}
                      helperText={sleepMinutesError}
                      inputProps={{
                        required: true,
                        placeholder: "30",
                      }}
                      sx={{
                        width: "140px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                  </div>
                  <hr />
                  <div className="mb-3">
                    <Button
                      type="submit"
                      color="success"
                      sx={{
                        backgroundColor: "rgb(25,135,84)",
                        fontSize: "15px",
                        marginRight: "25px",
                        padding: "5px 25px",
                        color: "white",
                      }}
                    >
                      Calculate
                    </Button>
                    <Button
                      sx={{
                        backgroundColor: "rgb(108,117,125)",
                        fontSize: "15px",
                        marginRight: "25px",
                        padding: "5px 25px",
                        color: "white",
                      }}
                      onClick={onReset2}
                    >
                      Clear
                    </Button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-7">
                {result2 && <pre>{result2}</pre>}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.healthCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Everything you need to know about sleep: how to calculate it and
                its importance in your system Daily
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>Sleep cycles</h2>
                </u>
                <br />
                <p>
                  The sleep cycle can be defined as the oscillation between
                  Rapid Eye Movement (REM) sleep and non-REM sleep, which will
                  be discussed below. The timing of sleep largely relies on
                  hormonal signals from the biological clock. The biological
                  clock exhibits a regular rhythm that aligns with external cues
                  (such as night/day) and can persist even if the external cues
                  suddenly disappear. An example of this is jet lag, where the
                  body's biological clock is affected due to rapid travel across
                  long distances, resulting in the traveler feeling either
                  delayed or ahead of their usual body time, which affects their
                  sleep. Ideally, a person's sleep cycle follows their
                  biological clock, but sleep can be influenced by various
                  factors such as light, social timing (when others are awake,
                  when work is required, etc.), napping, genetics, and more.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>REM و non-REM sleep</h2>{" "}
                </u>{" "}
                <br />
                <p>
                  During sleep, the brain consumes much less energy compared to
                  when a person is awake, especially during Rapid Eye Movement
                  (REM) sleep. REM sleep is a type of sleep characterized by
                  several aspects, including the eye movements it is named
                  after, temporary body paralysis, and the occurrence of dreams.
                  REM sleep and non-REM sleep are two distinct categories of
                  sleep. Typically, the body cycles between non-REM sleep and
                  REM sleep approximately every 90 minutes on average, occurring
                  4-6 times during a good night's sleep. Non-REM sleep begins
                  and eventually transitions into slow-wave sleep, or deep
                  sleep. During this period, body temperature and heart rate
                  decrease, and the brain consumes much less energy while
                  replenishing its supply of adenosine triphosphate (ATP), a
                  molecule used for energy storage and transfer. Slow-wave sleep
                  also involves the release of growth hormone, which is
                  particularly important for human growth. REM sleep usually
                  accounts for a smaller portion of total sleep time and is
                  commonly associated with dreaming or nightmares. Deprivation
                  of REM sleep can lead to anxiety, irritability,
                  hallucinations, and difficulty concentrating. Studies have
                  shown that when the body is deprived of REM sleep, subsequent
                  sleep will include an increased number of attempts to enter
                  REM sleep, as well as an increased amount of time spent in REM
                  sleep compared to periods without sleep deprivation. This is
                  referred to as REM rebound, which aligns with the belief that
                  REM sleep is necessary for the body. The full understanding of
                  REM sleep, its effects, and its necessity is still not
                  completely comprehended. While it is considered an important
                  and essential aspect of sleep, in some cases, temporary
                  positive effects can be observed from REM sleep deprivation.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Sleep quality</h2>
                </u>
                <br />
                <p>
                  The quality of sleep can be measured by the level of
                  difficulty a person faces in falling asleep and staying
                  asleep, as well as the number of times they usually wake up
                  during the night. It can also be measured subjectively by the
                  person's level of comfort upon waking up. Poor sleep quality
                  disrupts the sleep cycle and transitions between different
                  sleep stages. To achieve good sleep quality, the need for
                  sleep should be balanced with the daily sleep requirement.
                  Ideally, the timing of sleep should be balanced so that the
                  maximum concentration of melatonin hormone and the minimum
                  core body temperature occur after the midpoint of the sleep
                  period and before waking up.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    How much sleep do I need?
                  </h2>
                </u>
                <br />
                <p>
                  Sleep is not a completely understood concept, and the amount
                  of sleep a person needs can vary significantly based on
                  specific factors such as age and individual differences. A
                  person who gets sufficient sleep should not experience
                  excessive sleepiness or functional impairment during the day.
                  Generally, researchers have found that getting 6-7 hours of
                  sleep per night is associated with several positive health
                  outcomes, but there are also many other factors that can
                  influence these results. As a person ages, their sleep tends
                  to decrease, with newborns sleeping much longer hours than
                  adults. This discrepancy diminishes with age, and sleep
                  requirements become more similar to adult requirements
                  starting around the age of five. The following are the
                  recommendations from the Centers for Disease Control and
                  Prevention (CDC) for the number of hours a person should sleep
                  based on their age.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>Some illustrative tables:</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Recommended hours of sleep daily:
                </h3>
              </div>
              <div className="info-section-body">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#4caf50" }}>
                        <TableCell style={{ color: "white" }}>
                          Recommended hours of sleep per day (hours)
                        </TableCell>
                        <TableCell style={{ color: "white" }}>
                          Age group (Years)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data1.map((row, index) => (
                        <TableRow
                          key={row.ageGroup}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "white" : "#eeeeee",
                          }}
                        >
                          <TableCell>{row.recommendedHours}</TableCell>
                          <TableCell>{row.ageGroup}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default SleapCalculator;
